import { APP_URL } from '../config';

export default function CtaBand(): JSX.Element {
  return (
    <section className="container-page pb-20 md:pb-28">
      <div className="relative overflow-hidden rounded-3xl border border-border bg-gradient-to-br from-accent/20 via-surface to-surface px-6 py-14 text-center">
        <h2 className="text-3xl font-bold tracking-tight sm:text-4xl">
          Ready to see your Tesla in real time?
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-lg text-muted">
          Garage is invite-only for now. Request early access and we’ll email
          you a sign-up link once you’re approved — it’s free.
        </p>
        <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
          <a className="btn btn-primary btn-lg" href={`${APP_URL}/?request=1`}>
            Request early access
          </a>
          <a className="btn btn-ghost btn-lg" href={APP_URL}>
            Log in
          </a>
        </div>
      </div>
    </section>
  );
}
